import ComponentForm from 'components/Form';

import { contentfulProps } from 'utils/emptyTypes';

import type { FC } from 'react';

export type SubscribeFormProps = {
  test?: boolean;
  heading?: string;
  subhead?: string;
  formId?: string;
};

const SubscribeForm: FC<SubscribeFormProps> = ({ formId, heading, subhead }) => (
  <div className="hidden w-full flex-col gap-4 bg-subscribeform-overlay-dark p-4 lg:flex">
    <p className="text-lg font-bold text-white">{heading || 'Sign up for our newsletter'}</p>
    <p className="text-md text-white">
      {subhead ||
        'Request a demo to learn more about Aspire, the best in class employment and income verification service.'}
    </p>
    <div className="subscribe-form">
      <ComponentForm formId={formId} isSubscribe {...contentfulProps} />
    </div>
  </div>
);

export default SubscribeForm;
